import * as z from "zod";
import { discountRescueInput } from "./discount-rescue-shared";

/**
 * Shown-anchored funnel. `checkoutsShown`/`checkoutsClaimed`/`recoveredOrders` and
 * `endToEndRate` are what the dashboard renders; they are nullish so a client on
 * this schema still validates a response from a server that predates them.
 *
 * `failedDetected`/`claimed`/`ordered` are the v1 fields, kept required so the
 * reverse skew also holds: an app bundle still carrying the v1 schema keeps
 * validating responses from this server. Nothing renders them.
 */
export const getDiscountRescueFunnel = {
  name: "getDiscountRescueFunnel" as const,
  input: discountRescueInput,
  output: z.object({
    checkoutsShown: z.number().nullish(),
    checkoutsClaimed: z.number().nullish(),
    recoveredOrders: z.number().nullish(),
    // Recovered orders ÷ checkouts shown, as a percentage. Null when none shown.
    endToEndRate: z.number().nullish(),
    failedDetected: z.number(),
    claimed: z.number(),
    ordered: z.number(),
  }),
};
